import React, { useMemo, memo } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import EcoTabsSwiper, { EcoTabsSwiperItem } from 'eco-design/sections-test/eco-tabs-swiper';
import css from './index.module.scss';

const SectionF: React.FC<any> = ({}) => {
    const { t } = useLang('theProduct.SectionF');

    const items: EcoTabsSwiperItem[] = useMemo(
        () => [
            {
                tabLabel: t('tab1_label'),
                tabValue: '1',
                description: t('tab1_desc'),
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1761618262897/sectionf_1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1761633076199/sectionf_1_h5.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761633076199/sectionf_1_h5.jpg',
                    isOpenLazy: true,
                },
            },
            {
                tabLabel: t('tab2_label'),
                tabValue: '2',
                description: t('tab2_desc'),
                isVideo: true,
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/video/1761710102869/sectionf-video2.mp4',
                    pad: 'https://websiteoss.ecoflow.com/upload/video/1761791410149/sectionf-video_h5.mp4',
                    h5: 'https://websiteoss.ecoflow.com/upload/video/1761791410149/sectionf-video_h5.mp4',
                    poster: 'https://websiteoss.ecoflow.com/upload/image/1761618097279/sectionf_2.jpg',
                    posterH5: 'https://websiteoss.ecoflow.com/upload/image/1761638604995/sectionf_2_h5.jpg',
                },
            },
            {
                tabLabel: t('tab3_label'),
                tabValue: '3',
                description: t('tab3_desc'),

                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1761724357314/sectionf_3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1761900235486/sectionf_3_pad.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761724342509/sectionf_3_h5.jpg',
                    isOpenLazy: true,
                },
            },
        ],
        [t],
    );

    return (
        <div className={`${css.SectionF} eco-content GtmModuleData-section`} data-section-id="on-the-road-SectionF">
            <EcoSpace />
            <EcoTabsSwiper title={t('title')} className={css.comp} items={items} />
        </div>
    );
};

export default memo(SectionF);
